import "./bootstrap";
import initHeader from "./components/initHeader.js";
import initHelpers from "./components/initHelpers.js";
import initModals from "./components/initModals.js";
import initFormsSubmit from "./components/initFormsSubmit.js";
import initCookies from "./components/initCookies.js";

document.addEventListener("DOMContentLoaded", () => {

    if (window.location.hash === "#_=_") {
        history.replaceState(null, "", window.location.pathname + window.location.search);
    }

    // console.log("app.js");

    initHeader();
    initModals();
    initFormsSubmit();

    const { initScrollToTop } = initHelpers();
    initScrollToTop();

    initCookies();

});
